import { isOnline } from '../components/form/utils';
import { useEffect, useState, useRef } from 'react';

export default function useOnlineStatus() {
  const [isActuallyOnline, setIsActuallyOnline] = useState(false);
  const debounceRef = useRef(null);

  useEffect(() => {
    const check = async () => {
      const online = await isOnline();
      setIsActuallyOnline(online);
    };

    const debouncedCheck = () => {
      clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => {
        check();
      }, 500);
    };

    check(); // initial call

    window.addEventListener('online', debouncedCheck);
    window.addEventListener('offline', () => setIsActuallyOnline(false));

    return () => {
      window.removeEventListener('online', debouncedCheck);
      window.removeEventListener('offline', () => setIsActuallyOnline(false));
      clearTimeout(debounceRef.current);
    };
  }, []);

  return isActuallyOnline;
}
